var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4274_69450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2279 18.7321L20.9959 16.9641L22.7629 18.7321C23.1126 19.0817 23.3508 19.5271 23.4473 20.0121C23.5439 20.4971 23.4944 20.9998 23.3052 21.4566C23.116 21.9135 22.7956 22.304 22.3844 22.5787C21.9733 22.8535 21.4899 23.0001 20.9954 23.0001C20.5009 23.0001 20.0176 22.8535 19.6064 22.5787C19.1953 22.304 18.8749 21.9135 18.6857 21.4566C18.4965 20.9998 18.447 20.4971 18.5435 20.0121C18.6401 19.5271 18.8782 19.0817 19.2279 18.7321ZM8.87794 1.08008L20.1919 12.3931C20.2849 12.486 20.3587 12.5962 20.409 12.7176C20.4593 12.839 20.4852 12.9692 20.4852 13.1006C20.4852 13.232 20.4593 13.3621 20.409 13.4835C20.3587 13.6049 20.2849 13.7152 20.1919 13.8081L11.7069 22.2931C11.5194 22.4805 11.2651 22.5859 10.9999 22.5859C10.7348 22.5859 10.4805 22.4805 10.2929 22.2931L1.80794 13.8081C1.71496 13.7152 1.6412 13.6049 1.59088 13.4835C1.54055 13.3621 1.51465 13.232 1.51465 13.1006C1.51465 12.9692 1.54055 12.839 1.59088 12.7176C1.6412 12.5962 1.71496 12.486 1.80794 12.3931L9.58594 4.61508L7.46394 2.49408L8.87994 1.08008H8.87794ZM10.9999 6.03008L3.92894 13.1001L10.9999 20.1731L18.0709 13.1021L10.9999 6.02908V6.03008Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4274_69450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillColor);
export default __webpack_public_path__ + "static/media/fill-color.232b1bc368fb39b63912cf011889b51d.svg";
export { ForwardRef as ReactComponent };